import { useCallback } from 'react'
import {
  useSharedValue,
  withSpring,
  WithSpringConfig,
} from 'react-native-reanimated'

const useAnimatedPress = (config?: WithSpringConfig) => {
  const animation = useSharedValue(0)

  const onPressIn = useCallback(() => {
    animation.set(withSpring(1, config))
  }, [animation, config])

  const onPressOut = useCallback(() => {
    animation.set(withSpring(0, config))
  }, [animation, config])

  return {
    animation,
    onPressIn,
    onPressOut,
  }
}

export default useAnimatedPress
